import React, { createContext, useContext, useState, useEffect } from 'react';
import { partnerPortalAPI } from '../lib/partnerApi';

const PartnerAuthContext = createContext(null);

export function PartnerAuthProvider({ children }) {
  const [partner, setPartner] = useState(() => {
    try { return JSON.parse(localStorage.getItem('partner_data') || 'null'); } catch { return null; }
  });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('partner_token');
    if (!token) { setLoading(false); return; }
    partnerPortalAPI.me()
      .then((res) => {
        setPartner(res.data.partner);
        localStorage.setItem('partner_data', JSON.stringify(res.data.partner));
      })
      .catch(() => {
        localStorage.removeItem('partner_token');
        localStorage.removeItem('partner_data');
        setPartner(null);
      })
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const res = await partnerPortalAPI.login({ email, password });
    const { partner, accessToken } = res.data;
    localStorage.setItem('partner_token', accessToken);
    localStorage.setItem('partner_data', JSON.stringify(partner));
    setPartner(partner);
    return partner;
  };

  const logout = () => {
    localStorage.removeItem('partner_token');
    localStorage.removeItem('partner_data');
    setPartner(null);
  };

  return (
    <PartnerAuthContext.Provider value={{ partner, loading, login, logout }}>
      {children}
    </PartnerAuthContext.Provider>
  );
}

export function usePartnerAuth() {
  return useContext(PartnerAuthContext);
}
